import ScheduledPaymentsTable from './ScheduledPaymentsTable';

const FinalizePaymentPlanStep = () => {
  return (
    <div>
      <ScheduledPaymentsTable />
    </div>
  );
};

export default FinalizePaymentPlanStep;
